import Reveal from "./Reveal";

const STATS = [
  { value: "$14M+", label: "Recovered for Clients" },
  { value: "2,400+", label: "Families Helped" },
  { value: "48 States", label: "Service Coverage" },
  { value: "0%", label: "Upfront Cost — Ever" },
];

export default function Stats() {
  return (
    <section className="py-16 sm:py-20 bg-[#0F172A] text-[#F7F5F0] grain-bg" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div className="text-center md:text-left">
              <p className="font-serif-display font-bold text-4xl sm:text-5xl lg:text-6xl text-[#F7F5F0]">{s.value}</p>
              <p className="text-xs sm:text-sm text-[#F7F5F0]/70 mt-2 uppercase tracking-wider">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
